import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IEstimatesService } from "services/EstimatesService";
import { EstimateModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  Estimate: new EstimateModel({
    name: "",
    referenceNumber: 0,
    status: "",
    developmentNumber: "",
    developmentName: "",
  }),
  LoadingEstimate: false,
};

export const estimateSlice = createSlice({
  name: "estimate",
  initialState,
  reducers: {
    resetData: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEstimate.pending, (state) => {
        state.LoadingEstimate = true;
      })
      .addCase(getEstimate.rejected, (state) => {
        state.LoadingEstimate = false;
      })
      .addCase(getEstimate.fulfilled, (state, action) => {
        state.LoadingEstimate = false;
        state.Estimate = action.payload;
      });
  },
});

export const { resetData } = estimateSlice.actions;

export const getEstimate = createAsyncThunk("Estimates/GetEstimate", async (estimateID: string) => {
  const estimatesService = container.get<IEstimatesService>(SERVICE_TYPES.EstimatesService);
  return await estimatesService.getEstimate(estimateID);
});

export const selectLoadingEstimate = (state: RootState) => {
  return state.estimate.LoadingEstimate;
};

export const selectEstimate = (state: RootState) => {
  return state.estimate.Estimate;
};

export default estimateSlice.reducer;
